<script lang="ts">
    import { VpReturnIcon } from '@decathlon-experience/icons/svelte';

    import Button from '$saga/components/Button.svelte';
    // import { PaxFilterValues } from '$saga/views/Search/types';
    import NumberInput from '$saga/components/NumberInput.svelte';
    import { filtersContext } from '../store';

    // TODO dissociate nbPax in children and adults
    // export let childrenAges: string[] = [];
    // export let childrenValue: string;
    // export let adultsValue: string;
    export let handleValidateSelection: (value: string) => void;

    // 1 to 17 years old
    // const childAgeList = Array.from(Array(17)).map((v, index) => index + 1);

    // remote validate the selection (e.g dialog is closed from outside click)
    export const validateSelection = () => {
        // handleValidateSelection({
        //     childrenValue,
        //     adultsValue,
        //     childrenAges,
        // });
        handleValidateSelection($filtersContext.formValues.nbPax);
    };
</script>

<div class="flex h-full w-full flex-col gap-2xl">
    <div>
        <span class="hidden w-full px-m pt-m text-center desktop:block">
            Ajoutez un nombre de voyageurs
        </span>
    </div>

    <div class="flex items-center justify-between gap-xs">
        <div class="flex text-sm">Voyageurs</div>
        <NumberInput
            bind:value={$filtersContext.formValues.nbPax}
            min={0}
            onIncrement={() => {
                $filtersContext.formValues.nbPax = `${
                    Number($filtersContext.formValues.nbPax) + 1
                }`;
            }}
            onDecrement={() => {
                if (Number($filtersContext.formValues.nbPax) > 0)
                    $filtersContext.formValues.nbPax = `${
                        Number($filtersContext.formValues.nbPax) - 1
                    }`;
            }}
            minusBtnClasses={Number($filtersContext.formValues.nbPax) === 0
                ? 'text-bord-quiet'
                : ''}
            minusBtnProps={{
                disabled: Number($filtersContext.formValues.nbPax) === 0,
            }}
        />
    </div>

    <!-- <div class="flex flex-col gap-2xs">
        <div class="flex text-sm">Enfant(moins de 18 ans)</div>
        <NumberInput
            bind:value={childrenValue}
            min={0}
            onIncrement={() => {
                childrenValue = `${Number(childrenValue) + 1}`;
                // reactive value, do not use .push()
                childrenAges = [...childrenAges, ''];
            }}
            onDecrement={() => {
                if (Number(childrenValue) > 0) {
                    childrenValue = `${Number(childrenValue) - 1}`;
                    // mutate by removing last value
                    childrenAges = [...childrenAges.slice(0, -1)];
                }
            }}
            minusBtnClasses={Number(childrenValue) === 0
                ? 'opacity-[0.38]'
                : ''}
            minusBtnProps={{ disabled: Number(childrenValue) === 0 }}
        />
    </div> -->

    <!-- TODO dissociate nbPax in children and adults -->
    <!--{#if Number(childrenValue) > 0}-->
    <!--    <div>-->
    <!--        <p class="mb-xs text-content-quiet">-->
    <!--            Afin de vous proposer des séjours adaptés, nous avons besoin de-->
    <!--            connaîter l’âge qu’auront les enfants à la fin du séjour.-->
    <!--        </p>-->

    <!--        {#each childrenAges as _, index}-->
    <!--            <div class="mb-xl">-->
    <!--                <select-->
    <!--                    class="min-h-xl w-full px-m py-xs"-->
    <!--                    required-->
    <!--                    bind:value={childrenAges[index]}-->
    <!--                >-->
    <!--                    <option value="">Âge enfant {index + 1} </option>-->
    <!--                    {#each childAgeList as childrenAge}-->
    <!--                        <option value={childrenAge}>-->
    <!--                            {childrenAge}-->
    <!--                        </option>-->
    <!--                    {/each}-->
    <!--                </select>-->
    <!--            </div>-->
    <!--        {/each}-->
    <!--    </div>-->
    <!--{/if}-->

    <div
        class="sticky bottom-0 left-0 mt-auto flex w-full justify-between border-t border-solid border-border-quiet bg-white py-s"
    >
        <Button
            size="small"
            intent="secondary"
            shape="rounded"
            type="button"
            on:click={() => handleValidateSelection('0')}
            startIcon={VpReturnIcon}>Effacer</Button
        >
        <Button
            size="small"
            shape="rounded"
            type="button"
            on:click={() => validateSelection()}
        >
            Appliquer
        </Button>
    </div>
</div>
